<div class="d-flex flex-1"
    id="container" (resized)="onResized($event)">
    <kui-alert type="danger"
        class="mb-0 position-absolute w-100 key-alert-wrapper"
        style="z-index: 2000"
        *ngIf="errorMessage">
        <kui-icon name="ban"
            size="sm"></kui-icon>
        <span>{{errorMessage}}</span>
    </kui-alert>

    <div key-content-container
        class="map flex-1"></div>
    <kui-dropdown #contextMenuRef
        class="context-menu"
        [style]="'none'"
        [menu]="contextMenu"></kui-dropdown>
    <key-map-toolbar [controls]="activeControls"
        [isFullscreen]="isFullscreen"
        [baseLayers]="toolbarBaseLayers"
        [overlays]="overlays"
        [measurementDistance]="measurementDistance"
        [coordinates]="coordinates"
        [mapHeight]="hostHeight"
        (zoomIn)="map.zoomIn()"
        (zoomOut)="map.zoomOut()"
        (reset)="resetMap()"
        (zoneActivivated)="activateZoneEditing($event)"
        (zoneCancel)="cancelZoneEditing($event)"
        (zoneSave)="saveZoneEditing($event)"
        (zoneUndo)="undoZoneEditing()"
        (coordinatesOpen)="getCoordinates()"
        (coordinatesClose)="removeCoordinates()"
        (measurementsOpen)="startMeasurements(true)"
        (measurementsClose)="stopMeasurements()"
        (measurementsUndo)="measurementPolyline?.deleteLastVertex()"
        (openGoogleMaps)="openInGoogleMaps($event)"
        (fullscreen)="toggleFullscreen()"
        (markerAdd)="addMapMarker($event)"
        (markerRemove)="removeMapMarker($event)"
        (routesSet)="setRoutes($event)"
        (routesClear)="clearRoutes($event)"></key-map-toolbar>
    <div class="loading-overlay d-flex flex-stretch justify-content-center align-items-center"
        *ngIf="loading">
        <kui-loader></kui-loader>
    </div>
</div>